import { isVisible } from '../engine/anchors';
import { pressElement, waitUntil } from './formFill';

const DIALOG_SELECTOR = '[role="dialog"], [role="alertdialog"]';

function topmostDialog(): HTMLElement | null {
  const open = Array.from(document.querySelectorAll<HTMLElement>(DIALOG_SELECTOR)).filter(isVisible);
  return open.length > 0 ? open[open.length - 1] : null;
}

function closeControlIn(dialog: HTMLElement): HTMLElement | null {
  return (
    Array.from(dialog.querySelectorAll<HTMLElement>('button')).find(
      (button) => button.getAttribute('aria-label')?.trim().toLowerCase() === 'close' && isVisible(button),
    ) ?? null
  );
}

function pressEscape(): void {
  const event = new KeyboardEvent('keydown', {
    key: 'Escape',
    code: 'Escape',
    keyCode: 27,
    which: 27,
    bubbles: true,
    cancelable: true,
  } as KeyboardEventInit);
  document.dispatchEvent(event);
}

const MAX_LAYERS = 4;

const SETTLE_MS = 600;

export async function closeFlowChrome(
  isOpen: () => boolean,
  hook: 'afterEnd' | 'rewind' = 'afterEnd',
): Promise<boolean> {
  for (let attempt = 0; attempt < MAX_LAYERS && isOpen(); attempt += 1) {
    const dialog = topmostDialog();
    const closer = dialog ? closeControlIn(dialog) : null;

    if (closer) pressElement(closer);
    else pressEscape();

    await waitUntil(() => !isOpen(), SETTLE_MS);
  }

  if (isOpen()) {
    console.warn(
      `[tour-guide] ${hook}: a composer opened by the flow is still on screen after ` +
        `${MAX_LAYERS} attempts to close it. ` +
        (hook === 'afterEnd'
          ? 'The tour will resume behind it.'
          : 'The step Back is landing on will have nothing to highlight.'),
    );
    return false;
  }
  return true;
}
